import React, { RefObject } from "react";
import DataGrid from "../Components/DataGrid";
import { DataHelper } from "../Helpers/DataHelper";
import { PreviewProcedureModel } from "../Models/PreviewProcedureModel";
import { AppMode, DataGridColumn, DataGridRow, SortVal, viewType } from "../Helpers/SharedClasses";
import { PreviewMeasurement } from "../Models/PreviewMeasurement";
import { ErrorWindow } from "../Components/ErrorWindow";
import { StudyModel } from "../Models/StudyModel";
import { MeasurmentThumbnail } from "../Components/MeasurementThumbnail";
import { InfoBox } from "../Components/InfoBox";
import { PiFilePdfDuotone, PiTrash } from "react-icons/pi";
import { InputItem } from "../Components/InputItem";
import { StarPreview } from "../Components/StarPreview";
import { LabelModel } from "../Models/LabelModel";
import { Graft, TargetLocation } from "../Models/Trigger/TriggerClasses";
import SubwayMap from "../Models/Trigger/SubwayMap";
import { ExportModel } from "../Models/ExportModel";
import PeripheralDrawingOverlay from "../Models/Trigger/PeripheralDrawingOverlay";
import { PeripheralGraftPoints, VascularGraft, VascularHelpers } from "../Models/Trigger/VascularClasses";
import { StepLocationModel } from "../Models/StepLocationModel";
import CardiacWorklist from "../Models/Trigger/CardiacWorklist";
import CardiacSubwayMap from "../Models/Trigger/CardiacSubwayMap";


export class SearchWindow extends React.Component<
  {  userView: viewType, procedures: PreviewProcedureModel[], studySelected: StudyModel, dataHelper: DataHelper, showOtherWindow: (windowType: AppMode, additionalData: any) => void, toggleFilter: boolean, editMode: boolean, exportMode: boolean, procedureItemUpdated: (procId: string, columnChanged: string, value: string) => void,   repairMeasurementsClicked: ()=>void },
  {
    showEmptyFlows: boolean,
    options: string[],
    includeMeasurements: boolean
    newGraftToAdd: Graft | null

  }
> {

  ;

  errorWindow:  RefObject<ErrorWindow>;
  searchGrid: RefObject<DataGrid>;
  infoBox: RefObject<InfoBox>;
  constructor(props: any) {
      super(props);
    this.errorWindow = React.createRef();
    this.searchGrid = React.createRef();
    this.infoBox = React.createRef();
    let procParse: PreviewProcedureModel[] = this.props.procedures;
    let options: string[] = []
    procParse.map((procedure, index) => procedure.anatomicalLocations.forEach(location => {
      if (!options.includes(location) && /^[a-zA-Z]+$/.test(location)) {
        options.push(location)
      }
    }
    ))
    this.state = {
      showEmptyFlows: false,
      options: options,
      includeMeasurements: true,
      newGraftToAdd: null
    }
  }


  static defaultProps = {
    //Set any properties that are optional when creating the component.
    exportMode: false
}

  componentDidMount(){
    if(this.props.studySelected.name==="")
    {(this.errorWindow.current as ErrorWindow).show(400, "")}
  }

  stringToColor(str: string): string {
    let hash = 0;
    if (!str || str.length === 0) {
      return 'red';
    }

    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = (hash*19) % 360;
    return `hsl(${hue}, 50%, 80%)`; // Here, we set the saturation to 100% and lightness to 75%
  }

  
  //Put these in a helper class somewhere common to avoid redefinition.
  renderKeyValueInGrid = (item: any) => {
    if (item as number) {
      return <div>{(item as number).toFixed(2)}</div>
    } else {
      return <div>--</div>
    }
  }
  renderSizeValueInGrid = (item: any) => {
    if (item as number) {
      return <div>{(item as number).toFixed(1)}</div>
    } else {
      return <div>--</div>
    }
  }
  renderDepthValueInGrid = (item: any) => {
    if (item as number) {
      return <div>{(item as number * 1000).toFixed(0)}</div>
    } else {
      return <div>--</div>
    }
  }

  
  //Put these in a helper class somewhere common to avoid redefinition.
  renderMeanValueInGrid = (item: any) => {

    let meanValue = Math.abs((item as number * 1000));
    let lowerValue = this.props.studySelected.lowerReferenceValue as number;
    let upperValue = this.props.studySelected.upperReferenceValue as number;
      let meanflowColor = ( meanValue< lowerValue? this.props.studySelected.meanWorstColor: meanValue > upperValue? this.props.studySelected.meanGoodColor: this.props.studySelected.meanBadColor);
    // let meanflowClassname = (meanValue < lowerValue ? "meanflowThumbnailRed" : meanValue > upperValue ? "meanflowThumbnailGreen" : "meanflowThumbnailYellow")

    if (item as number) {
      return <div style={{backgroundColor: meanflowColor}}>{(item as number * 1000).toFixed(2)}</div>
    } else {
      return <div>--</div>
    }
  }

  renderListInGrid = (items: string[]) => {
    let valToShow = "";

    let itemsAdded: string[] = [];

    if (items) {
      for (let index = 0; index < items.length; index++) {
        const element = items[index];
        //No repeats!
        if (itemsAdded.indexOf(element) === -1)
        {
          itemsAdded.push(element);
          valToShow += element;
          if (index < items.length - 1)
            valToShow += " - ";
        }
      }
      return <div className="data-grid-cell">{valToShow}</div>;
    }
  }
  renderToButton = (item: any, rowItem: any) => {

    return <div className="createReport">
      <button className="primaryButton" onClick={() => {
        this.props.showOtherWindow(AppMode.Report, rowItem);


        // this.props.dataHelper.CallMetadataService("CreateReport", {}, {studyid: this.props.studySelected.id, procedureid: rowItem.id}, (dataout: string)=>
        // {
        //   (this.infoBox as InfoBox).show("PDF-report successfully generated: " + dataout);
        // });
      }}><PiFilePdfDuotone /></button>
    </div>
  }
  
  averagingTemplate = (rows: DataGridRow[], columnName: string, columnValueFunc?: (row: DataGridRow)=>number)=>
  {
    let runningTotal = 0;
    let totalRows = 0;
    
    for (let index = 0; index < rows.length; index++) {
      const element = rows[index];
      if ((element as any)[columnName] > 0)
      {
        totalRows++;
        if(columnValueFunc)
        {
          let valueIn = columnValueFunc(element);
          if (valueIn > 0)
          {
            runningTotal = runningTotal + valueIn;
          }else
          {
            totalRows--;
          }
        }else
          runningTotal = runningTotal + (element as any)[columnName];
      }
      
    }
    let averageNum = 0;
    if (totalRows > 0 )
      averageNum = (runningTotal/totalRows);
    return <>Avg: {averageNum > 0 ? averageNum.toFixed(1) : "--"}</>;
  }

  handleErrorBox=(error:string)=>{(this.errorWindow.current as ErrorWindow).show(700,error)}
  handleInfoBox=(info:string)=>{(this.infoBox.current as InfoBox).show(info)}

  exportData = () => {



    let exportData: ExportModel = {includeMeasurements: this.state.includeMeasurements, procedures: [], studyId: (this.props.studySelected.id as string) }
    
    if (this.props.toggleFilter){
      let filteredData: PreviewProcedureModel[] = [...(this.searchGrid.current as DataGrid).getFilteredData(this.state.includeMeasurements, true) as PreviewProcedureModel[]] ;
      exportData.procedures = filteredData.filter(data => data.selected);
    }else
    {
      exportData.procedures = this.props.procedures;
    }
    this.props.dataHelper.CallMetadataService("ExportData", exportData,{}, (resultOut: string) => {
      let filename = JSON.parse(resultOut);
       this.props.dataHelper.downloadFile("StudyMetadata", "GetFile", {fileid: filename})
    },(status:number, errorMessage:string)=>{ (this.errorWindow.current as ErrorWindow).show(status, errorMessage)},"POST");
  }

  downloadRawData = () => {



    let exportData: ExportModel = {includeMeasurements: this.state.includeMeasurements, procedures: [], studyId: (this.props.studySelected.id as string) }
    
    if (this.props.toggleFilter){
      let filteredData: PreviewProcedureModel[] = [...(this.searchGrid.current as DataGrid).getFilteredData(this.state.includeMeasurements, true) as PreviewProcedureModel[]] ;
      exportData.procedures = filteredData.filter(data => data.selected);
    }else
    {
      exportData.procedures = this.props.procedures;
    }
    this.props.dataHelper.CallMetadataService("DownloadRawData", exportData,{}, (resultOut: string) => {
      let filename = JSON.parse(resultOut);
       this.props.dataHelper.downloadFile("StudyMetadata", "GetFile", {fileid: filename})
    },(status:number, errorMessage:string)=>{ (this.errorWindow.current as ErrorWindow).show(status, errorMessage)},"POST");
  }

  addColumn = (gridType: string, columnsIn: DataGridColumn[], columnToAdd: DataGridColumn) =>
  {
    let columnsToAdd: string[] = [];
    if (this.props.userView === viewType.Minimal)
    {
    if (gridType === "Main")
    {
      
      columnsToAdd = ["selected", "createdDate", this.props.studySelected.idFieldForStudy ? this.props.studySelected.idFieldForStudy : "comments", "importDate", "otherComments"];
    } else if (gridType === "Child")
    {
      columnsToAdd = ["thumbnails"];
    }
    }
    if (columnsToAdd.length === 0 ||  columnsToAdd.indexOf(columnToAdd.Name) > -1)
    {
      columnsIn.push(columnToAdd);
    }
    
  }

  getChildColumns = (steps: string[] ) =>  {
    let childGridColumns: DataGridColumn[] = [];

   
        this.addColumn("Child", childGridColumns,  {
        Name: "delete", Caption: "Delete", RenderTemplate: (rowData, row: PreviewMeasurement, parentRow: PreviewProcedureModel) => (
          <PiTrash className="buttonIcon" onClick={() => {
  
            for (let index2 = 0; index2 < parentRow.measurements.length; index2++) {
              const measurement = parentRow.measurements[index2];
              if (measurement.id === row.id) {
                parentRow.measurements.splice(index2, 1);
              }
            }
            //  let proceduresIn = this.state.procedures;
            //   for (let index = 0; index < proceduresIn.length; index++) {
            //     const element = proceduresIn[index];
            //     if (element.id === parentRow.id)
            //       {
            //     for (let index2 = 0; index2 < element.measurements.length; index2++) {
            //       const measurement = element.measurements[index2];
            //       if (measurement.id === row.id)
            //       {
            //           proceduresIn.splice(index, 1);
            //       }
            //     }
  
            //   }
            // this.setState({
            //   procedures: proceduresIn
            // });
            // }
            //this.handleDelete(rowData)
            this.props.dataHelper.CallStudyService("SaveProcedure", { studyId: this.props.studySelected.id, previewProcedure: parentRow, deleteMeasurementId: row.id }, {}, (dataOut: string) => {
  
  
  
              //   if (dataOut === "DONE")
              //   {
              //     let proceduresIn = this.state.procedures;
              //     for (let index = 0; index < proceduresIn.length; index++) {
              //       const element = proceduresIn[index];
              //       if (element.id === parentRow.id)
              //         {
              //       for (let index2 = 0; index2 < element.measurements.length; index2++) {
              //         const measurement = element.measurements[index2];
              //         if (measurement.id === row.id)
              //         {
              //             proceduresIn.splice(index, 1);
              //         }
              //       }
  
              //     }
              //     this.setState({
              //       procedures: proceduresIn
              //     });
              //   }
  
              // }
            }, () => { }, "POST");
          }
          } />
        )
      }
      );
    
    if (this.props.exportMode)
      {
        if (this.props.studySelected.exportEnabled)
          {
            this.addColumn("Child", childGridColumns,  {Name: "selected", Caption: "Export", Type:"boolean", Editable: true });
                  
          }
      }

    // let childGridColumns: DataGridColumn[] = [
      this.addColumn("Child", childGridColumns, {Name: "qualified", Caption: "Qualified", Type: "boolean"});
      this.addColumn("Child", childGridColumns, {Name: "index", Caption: "Name"});
        this.addColumn("Child", childGridColumns, {Name: "isBestMeasurement", Caption: "Best Measurement", Type: "boolean"});
          this.addColumn("Child", childGridColumns, {Name: "measurementType", Caption: "Type"});
  
            this.addColumn("Child", childGridColumns, {Name: "recordDate", Caption: "Date", Type: this.props.studySelected.allowPersonalData || this.props.studySelected.allowFullDateOnly ? "date" : "datenoday"});
              this.addColumn("Child", childGridColumns, {Name: "mean", Caption: "MF", Type: "number", RenderTemplate: this.renderMeanValueInGrid, SummaryTemplate: (rows: DataGridRow[])=>{

        let totalSum = 0;
        let totalCount = 0;
        for (let loopindex = 0; loopindex < rows.length; loopindex++) {
          const element = rows[loopindex] as PreviewMeasurement;
          if (element.measurementType  === "Flow" && element.mean && !Number.isNaN(element.mean))
          {   totalSum += Math.abs(element.mean)*1000;
            totalCount++;
          }
         
        }
        return <td>Avg: { totalCount ? (totalSum/totalCount).toFixed(2) : "--"}</td>

      }});
      this.addColumn("Child", childGridColumns, {Name: "pI", Caption: "PI",  Type: "number", RenderTemplate: this.renderKeyValueInGrid});
        this.addColumn("Child", childGridColumns, {Name: "dF", Caption: "DF", Type: "number",  RenderTemplate: this.renderKeyValueInGrid});
          this.addColumn("Child", childGridColumns, {Name: "probeSize", Caption: "Probe size (mm)", Type: "number", RenderTemplate: this.renderSizeValueInGrid});
            this.addColumn("Child", childGridColumns, {Name: "imageDepth", Caption: "Depth (mm)", Type: "number", RenderTemplate: this.renderDepthValueInGrid});
              this.addColumn("Child", childGridColumns, {Name: "operatingMode", Caption: "Mode", Type: "number"});
                this.addColumn("Child", childGridColumns,  {Name: "phasicityPreview", Caption: "Phasicity"});
      // {Name: "anatomicalLocations", Caption: "Anatomical Locations", RenderTemplate:  this.renderListInGrid},
      this.addColumn("Child", childGridColumns, {Name: "measurements", Type:"dropdownMultipleSelect", FilterOptions:this.state.options, Caption: "Labels", RenderTemplate: (item: PreviewMeasurement[], rowItem: PreviewMeasurement, parentRow)=>{
        let suggestedLabels: string[] = [];
        
     
        var labels=rowItem.labels;
        if(labels){
        for (let index = 0; index < labels.length; index++) {
          const element = labels[index].suggestedLabels
          if (element)
          {
          for (let j = 0; j < element.length; j++) {
            suggestedLabels.push(element[j].name) 
          } 
          
            
        }
        }
      }
        
        
        
        let uniqueLabels = Array.from(new Set(suggestedLabels));

        if (rowItem.isIntui && rowItem.intuiGraft)
            {
              uniqueLabels = [];
              Graft.getGraftName(rowItem.intuiGraft as Graft, uniqueLabels);
              uniqueLabels = Array.from(new Set(uniqueLabels));
            }

        if (uniqueLabels && uniqueLabels.length > 0) {
          return (
            <div>
              {uniqueLabels.map((label, index) => (
                <div key={index} className={"labelInDataGrid"} style={{backgroundColor: this.stringToColor(label)}}>
                  {label}
                </div>
              ))}
            </div>
          );
        }else
        {
          let suggestedLabels: string = "";
          let isAdded: string[]  = [];
         
            if (labels) {
              labels.forEach(label => {
                if (isAdded.indexOf(label.name) === -1)
                {
                  if (suggestedLabels)
                  suggestedLabels +=" - ";
                  suggestedLabels += (label.name);
                  isAdded.push(label.name);
                }
              });
            }
          

            
            return <div>{suggestedLabels? suggestedLabels : rowItem.anatomicalLocations}</div>;
        }


      }});
      this.addColumn("Child", childGridColumns, {Name: "subwaymap", Caption: "Subway Map", RenderTemplate: (item: PreviewMeasurement[], rowItem, parentRow)=>{

        if ((rowItem as PreviewMeasurement).isIntui && (rowItem as PreviewMeasurement).intuiGraft)
        {
          let subwayMap: React.ReactElement = (this.props.studySelected.studyType === "Cardiac" ?
                            <CardiacSubwayMap parentProcedure={null as any} protocolSteps={[]} showeditbutton={false}  CurrentItem={(rowItem as PreviewMeasurement).intuiGraft as Graft}  showSelected={true} showsaves={false}></CardiacSubwayMap>
                            :
                            <SubwayMap CurrentItem={(rowItem as PreviewMeasurement).intuiGraft as Graft} Context={"TTFM"} customGraftText={""} index={0} commentToggled={function (e: boolean): void {
                                throw new Error("Function not implemented.");
                            } } measurementSelectionOpen={false} measurementSelectionSelected={function (e: boolean): void {
                                throw new Error("Function not implemented.");
                            } } tileColorOn={false} ></SubwayMap>);
          return (
            <div>
              {subwayMap}
              
            </div>
          );
        }else
        {
        let suggestedLabels: LabelModel[] = [];
         //Remove label duplicates
         let newLabelList = [];
         let labelsAdded = [];
         if (rowItem && rowItem.labels)
         {
      for (let index = 0; index < rowItem.labels.length; index++) {
        const element = rowItem.labels[index];
        if (labelsAdded.indexOf(element.id) === -1)
        {
          labelsAdded.push(element.id);
          newLabelList.push(element);
        }
      
      }
    }
        if (newLabelList) {
          newLabelList.forEach((label: LabelModel) => {
            if(label.suggestedLabels){
            suggestedLabels=[...suggestedLabels,...label.suggestedLabels];}
          });
        }
        let subwayMap: React.ReactElement = <div></div>;
        let uniqueLabels = Array.from(new Set(suggestedLabels));

        if (uniqueLabels) {
          let graftOut=Graft.GenerateGrafts([uniqueLabels])
          if (graftOut.length > 0 && !graftOut[0].blankNewItem)
          {
              subwayMap = (this.props.studySelected.studyType === "Cardiac" ?
                            <CardiacSubwayMap parentProcedure={null as any} protocolSteps={[]} showeditbutton={false}  CurrentItem={graftOut[0]}  showSelected={true} showsaves={false}></CardiacSubwayMap>
                            :
                            <SubwayMap CurrentItem={graftOut[0]} Context={"TTFM"} customGraftText={""} index={0} commentToggled={function (e: boolean): void {
                                throw new Error("Function not implemented.");
                            } } measurementSelectionOpen={false} measurementSelectionSelected={function (e: boolean): void {
                                throw new Error("Function not implemented.");
                            } } tileColorOn={false} ></SubwayMap>);
           
          }
          return (
            <div>
              {subwayMap}
              
            </div>
          );
        }
        }


      },FilterTemplate: (item: any) => {return <></>}});

      // this.addColumn("Child", childGridColumns, {Name: "designer", Caption: "Designer", RenderTemplate: (item, rowItem, parentRow) => {
      //   let height = 270;
      //   let width = 260;
      //   return <div className="thumbItem"><div className="mainDrawingContainer" style={{height: height, width: width}}><PeripheralDrawingOverlay absxOffset={-20} absyOffset={-10} height={height} width={width} Context="TTFM" drawDebugLine={false} selectedProcedure={{name: "PeripheralBypass", title: "", type: "Vascular"}} heartxOffset={0 } heartyOffset={-30} GraftsLoaded={[]} customGraftLocation={new TargetLocation()} heartTargetsShow={false} heartOutlineShow={true} editGraftClicked={()=>{}} graftSelected={new Graft()}></PeripheralDrawingOverlay></div></div>;

      // },});

      this.addColumn("Child", childGridColumns, {Name: "thumbnails", Caption: "Thumbnail", RenderTemplate: (item: string, rowItem: any, parentRow) => {

        let itemsOut = [];
        let addMeasurement = true;
        if (this.props.userView === viewType.Minimal && (rowItem as PreviewMeasurement).measurementType === "Ecg")
          addMeasurement = false;

        if (addMeasurement)
        {
          let hasMissing = false;
          if ((parentRow as PreviewProcedureModel))
          {
            if (rowItem.index === 0)
            {    
              if ( (parentRow as PreviewProcedureModel).missingData)
                hasMissing = true;
            }
          }
          if (rowItem.index === 0 && this.props.studySelected.studyType === "Vascular")
            {
             
               
              
            }

          
          //Lets check if the measurement has been allocated to a step location yet.
          let isAllocated = false;
          if ((rowItem as PreviewMeasurement).stepLocations && ((rowItem as PreviewMeasurement).stepLocations as StepLocationModel[]).length > 0)
          {
              isAllocated = true;
          }

          let isDraggable = false;
          if (this.props.userView === viewType.Minimal)
          {
          if ( this.props.studySelected.studyType === "Vascular")
          {
             let graftBoxes = [];

            let graftsLoaded = VascularHelpers.createGraftsFromLabels((parentRow as PreviewProcedureModel).anatomicalLocations);
                    // let vesselMeasurementsLocal = this.state.vesselMeasurements;
                    Object.keys(PeripheralGraftPoints).forEach(vessel => {
                                    let isAdded = VascularHelpers.recursePointsNoHemisphere(((graftsLoaded.length > 0 ? graftsLoaded[0] : {}) as VascularGraft), vessel as PeripheralGraftPoints);
                                    if (isAdded)
                                    {
                                        graftBoxes.push(vessel);
                                        
                                    }
                        });
            if (!isAllocated && graftsLoaded.length > 0)
              isDraggable = true;
          }else
          {

            isDraggable = (rowItem as PreviewMeasurement).intuiGraft === null;
          }
        }

          if (hasMissing)
            itemsOut.push(<MeasurmentThumbnail repairMeasurementsClicked={this.props.repairMeasurementsClicked} key={"measurementssub" +  rowItem.id} studySelected={this.props.studySelected} dataHelper={this.props.dataHelper} procedureId={"repair"} rowData={rowItem as PreviewMeasurement} detailed={true} expanded={()=>{
                          }}></MeasurmentThumbnail>);

          let possibleBlankMeasurement = rowItem.measurementType === 'Flow' && rowItem.mean === 0 && rowItem.lastACI < 10;
          if (this.state.showEmptyFlows || !possibleBlankMeasurement)                
            itemsOut.push(<MeasurmentThumbnail parentRefresh={()=>{}} orientationChanged={(orientation)=>{this.orientationChanged(orientation, parentRow.id, rowItem.id);}} draggable={isDraggable} key={"measurementssub" +  rowItem.id} studySelected={this.props.studySelected} dataHelper={this.props.dataHelper} procedureId={parentRow.id} rowData={rowItem as PreviewMeasurement} detailed={true} expanded={()=>{

          }}></MeasurmentThumbnail>);
        


        }
        if (itemsOut && itemsOut.length > 0)
          return <div className="thumbnails-container">{itemsOut}</div>;
        else
          return <></>;
      }
    });
      this.addColumn("Child", childGridColumns, { Name: "otherComments", Caption: "Comments", Editable: this.props.editMode, Type: "textarea" });
      this.addColumn("Child", childGridColumns, { Name: "protocolStep", Caption: "Protocol Step", Type: "dropdown", ValueList: steps, Editable: true, ShowValueOncePerAlternate: true });
  

  

    return childGridColumns;
  }

  getMainColumns = (labelOptions: string[] ,hospitalsList: string[] ) =>  {
    let mainGridColumns: DataGridColumn[] = [];


    if (this.props.editMode) {
      //Insert delete buttons
     
        this.addColumn("Main", mainGridColumns, {
        Name: "delete", Caption: "Delete", RenderTemplate: (rowData, row: PreviewProcedureModel) => (
          <PiTrash className="buttonIcon" onClick={() => {
            //this.handleDelete(rowData)
            this.props.dataHelper.CallStudyService("DeleteProcedure", { studyId: this.props.studySelected.id, procedureId: row.id }, {}, (dataOut: string) => {
              if (dataOut)
              {
                  let toShow = dataOut;
              if (toShow === "DONE") {
                let proceduresIn = this.props.procedures;
                for (let index = 0; index < proceduresIn.length; index++) {
                  const element = proceduresIn[index];
                  if (element.id === row.id) {
                    proceduresIn.splice(index, 1);
                  }
                }
              }
                // this.setState({
                //   procedures: proceduresIn
                // });
              }


            }, () => { }, "DELETE");
          }
          } />
        )
      }
      );
    
  }
   

    if (this.props.exportMode)
    {
      if (this.props.studySelected.exportEnabled)
        {

          this.addColumn("Main", mainGridColumns, {Name: "selected", Caption: "Export", Type:"boolean", Editable: true, AdditionalFilter: (item: any) => {
        /*
        item.forEach(element => {
          if(element.measurementType=="Flow" || )
        });*/
        return (
          <> 
           <InputItem title="Hospital name"  type="dropdown" name="hospitalName" options={hospitalsList}  deleteOption={(value) => { (this.searchGrid.current as DataGrid).removeFilter("phasicityPreview", value) }} onChange={(name, value, value2) => {
            (this.searchGrid.current as DataGrid).handleSort("HospitalName","hospitalName", value, null, "hospitalName", undefined, "dropdown", true)
          }} /></>)
      } });
                
    }
    

    this.addColumn("Main", mainGridColumns, { Name: "qualified", Caption: "Qualified" , Type:"boolean", SummaryTemplate: (rows: DataGridRow[]) =>
      {
        let totalQualifiedMeasurements =  rows.length;
        for (let index = 0; index < rows.length; index++) {
          const element = rows[index] as PreviewProcedureModel;
          //totalRows += element.measurements.length;
          for (let measindex = 0; measindex < element.measurements.length; measindex++) {
            const measurementIn = element.measurements[measindex];
            if (measurementIn.qualified)
            {
              totalQualifiedMeasurements++;
            }
          }
        }
 
        return <div className="subTotalDisplay">
                <span className="subTotalDisplayItem">Total: {totalQualifiedMeasurements}</span>
            </div>;
            
      }
      
    });
    this.addColumn("Main", mainGridColumns, 
      { Name: "createdDate", Caption: "Date", Type: this.props.studySelected.allowPersonalData|| this.props.studySelected.allowFullDateOnly  ? "date" : "datenoday" });
      if (this.props.studySelected.allowPersonalData)
        {
      this.addColumn("Main", mainGridColumns, { Name: "patientId", Caption: "Patient Id", Type: "encryptable" });
        }
        this.addColumn("Main", mainGridColumns, {
        Name: "starRating", Caption: "Rating", Type: "star", RenderTemplate: (starRating, item: PreviewProcedureModel) => {

          // let ratings = new Map<string,number>();
          let ratings: string = "Total rating: " + item.starRating?.toFixed(2) as string + ", ";
          let attributes = ["Labels", "Missing data", "Protocol steps", "Imaging", "Saves", "ECG", "Comment"];
          let ratingsData = item.specificRatings as number[];
          for (let i = 0; i < attributes.length; i++) {

            ratings += (attributes[i] + ": " + ratingsData[i] + ", ");
          }
          ratings.trimEnd();

          if (this.props.studySelected.idFieldForStudy)
          {
            if (!((item as any)[this.props.studySelected.idFieldForStudy]))
            {
              //if the study has an explicit id field and the value of that field is blank then give it a zero rating.
              item.starRating = 0;
            }
          }
          return <div title={ratings} className="datagridStars"><StarPreview value={item.starRating as number}></StarPreview></div>;
        },
      });
      this.addColumn("Main", mainGridColumns, { Name: "comments", Caption: "Comments", Editable: false });
      this.addColumn("Main", mainGridColumns, { Name: "importDate", Caption: "Import date", Type: "date" });
      if (this.props.studySelected.allowPersonalData)
      {
      this.addColumn("Main", mainGridColumns, { Name: "height", Caption: "Height", Type: "int", ignoreChildren: true, SummaryTemplate: (rows)=>
      {
        return this.averagingTemplate(rows, "height");
      }});
      this.addColumn("Main", mainGridColumns, { Name: "weight", Caption: "Weight", Type: "int", ignoreChildren: true, SummaryTemplate: (rows)=>
        {
          return this.averagingTemplate(rows, "weight");
        }});
        this.addColumn("Main", mainGridColumns, { Name: "gender", Caption: "Gender", Type: "gender", ignoreChildren: true});
        this.addColumn("Main", mainGridColumns, { Name: "age", Caption: "Age", Type: "interval", ignoreChildren: true, RenderTemplate: (item: PreviewMeasurement[], rowItem: PreviewProcedureModel, parentRow)=>
      {
        let yearOut = 0;
        if (rowItem.createdDate)
        {
          try{

        
            let dateParsed: Date = new Date(rowItem.createdDate);
            yearOut = dateParsed.getFullYear();
          }catch(ex1)
          {}
        }
        if (rowItem.birthYear as number && rowItem.birthYear > 0 && yearOut && yearOut > rowItem.birthYear) {
          return <div>{yearOut -  rowItem.birthYear}</div>
        } else {
          return <div>--</div>
        }

      }, SummaryTemplate: (rows) =>
      {
      return this.averagingTemplate(rows, "birthYear", (row: DataGridRow)=>{
        let rowItem = row as PreviewProcedureModel;
        let yearOut = 0;
        if (rowItem.createdDate)
        {
        
          try{

        
            let dateParsed: Date = new Date(rowItem.createdDate);
            yearOut = dateParsed.getFullYear();
          }catch(ex1)
          {}
        }
        if (rowItem.birthYear as number && rowItem.birthYear > 0 && yearOut && yearOut > rowItem.birthYear) {
          return yearOut -  rowItem.birthYear;
        }
        return 0;
      })
      }
       });
      }
      // { Name: "anatomicalLocations", Type: "dropdownMultipleSelect", FilterOptions: this.state.options, Caption: "Anatomical Locations", RenderTemplate: this.renderListInGrid },
      this.addColumn("Main", mainGridColumns, {Name: "labels", Type:"dropdownMultipleSelect", FilterOptions:labelOptions, Caption: "Labels", RenderTemplate: (item: PreviewMeasurement[], rowItem: PreviewProcedureModel, parentRow)=>{
        
        let suggestedLabels: string[] = [];
        if (rowItem.measurements)
        {
        rowItem.measurements.forEach(element => {
          if (element.labels) {
            element.labels.forEach(label => {
              label.suggestedLabels?.forEach(sug=>{
                if (suggestedLabels.indexOf(sug.name) === -1)
                suggestedLabels.push(sug.name);
              })
            });
          }

          

          if (element.isIntui && element.intuiGraft)
            {
              let intuiLabels: string[] = [];
              Graft.getGraftName(element.intuiGraft as Graft, intuiLabels);
              suggestedLabels.push(...intuiLabels);
            }

        });
      }
        let uniqueLabels = Array.from(new Set(suggestedLabels));

        if (uniqueLabels && uniqueLabels.length > 0) {
          return (
            <div className="tabColoring">
              {uniqueLabels.map((label, index) => (
                <div key={index} className={"labelInDataGrid"} style={{backgroundColor: this.stringToColor(label)}}>
                  {label}
                </div>
              ))}
            </div>
          );
        }else
        {
          let suggestedLabels: string = "";
          let isAdded: string[]  = [];
          if (rowItem.measurements)
        {
        rowItem.measurements.forEach(element => {
            if (element.labels) {
              element.labels.forEach(label => {
                if (isAdded.indexOf(label.name) === -1)
                {
                  if (suggestedLabels)
                  suggestedLabels +=" - ";
                  suggestedLabels += (label.name);
                  isAdded.push(label.name);
                }
              });
            }
          });

        }

            return <div>{suggestedLabels? suggestedLabels : Array.from(new Set(rowItem.anatomicalLocations))}</div>;
        }

      }, AdditionalFilter: (item: any) => {
        /*
        item.forEach(element => {
          if(element.measurementType=="Flow" || )
        });*/
        return (
          <> <InputItem title="Probe Size" type="interval" name="measurements" deleteOption={(value) => { (this.searchGrid.current as DataGrid).removeFilter("probeSize", value) }} onChange={(name, value, value2) => {
            (this.searchGrid.current as DataGrid).handleSort("Measurement",name, value, value2, "probeSize")
          }} />

        <InputItem title="Image depth" type="interval" name="measurements" deleteOption={(value) => { (this.searchGrid.current as DataGrid).removeFilter("imageDepth", value) }} onChange={(name, value, value2) => {
            (this.searchGrid.current as DataGrid).handleSort("Measurement",name, value/1000, value2/1000, "imageDepth")
          }} />
          { this.props.userView === viewType.Advanced ?
          <>
        <InputItem title="ID"  type="text" name="id" onChange={(name, value, value2) => {
            (this.searchGrid.current as DataGrid).handleSort("Measurement","measurements", value, null, "id")
          }} />
           <InputItem title="Phasicity"  type="dropdown" name="phascityPreview" options={["--Select--","Unknown", "Monophasic", "Biphasic", "Triphasic"]}  deleteOption={(value) => { (this.searchGrid.current as DataGrid).removeFilter("phasicityPreview", value) }} onChange={(name, value, value2) => {
            (this.searchGrid.current as DataGrid).handleSort("Measurement","measurements", value, null, "phasicityPreview")
          }} />
          <InputItem title="Mode"  type="dropdown" name="operatingMode" options={["--Select--","0", "1", "2", "3"]}  deleteOption={(value) => { (this.searchGrid.current as DataGrid).removeFilter("operatingMode", value) }} onChange={(name, value, value2) => {
            (this.searchGrid.current as DataGrid).handleSort("Measurement","measurements", value, null, "operatingMode")
          }} /></>
          : <></>}
          </>)
      }
      , SummaryTemplate: (rows: DataGridRow[]) =>
        {
          let totalProbeSize = 0;
          let totalRows = 0;
          let totalProbeSizeRows = 0;

          let totalMap = 0;
          let totalMapRows = 0;

          for (let index = 0; index < rows.length; index++) {
            const element = rows[index] as PreviewProcedureModel;
            totalRows += element.measurements.length;
            for (let measindex = 0; measindex < element.measurements.length; measindex++) {
              const measurementIn = element.measurements[measindex];
              if (measurementIn.measurementType === "Flow")
              {
              if (!Number.isNaN(measurementIn.probeSize) && measurementIn.probeSize as number > 0)
              {
                totalProbeSize += (measurementIn.probeSize as number);
                totalProbeSizeRows++;
              }

              if (!Number.isNaN(measurementIn.mAPMean) && measurementIn.mAPMean as number > 0)
              {
                totalMap += (measurementIn.mAPMean as number);
                totalMapRows++;
              }

            }
             
            }
         
          }
            return <div className="subTotalDisplay">
              {
                totalRows > 0   ?
                <>
                <span className="subTotalDisplayItem">Avg probe size: {totalProbeSizeRows > 0 ? (totalProbeSize/totalProbeSizeRows).toFixed(1) : "--"}</span>
                <span className="subTotalDisplayItem">Avg MAP: {totalMapRows > 0 ? (totalMap/totalMapRows).toFixed(1) : "--"}</span>
                </>
             :
                <></>
              }
              
            </div>;
        }
      });
      this.addColumn("Main", mainGridColumns, {
        Name: "flowMeasurements", Caption: "Flow", Type: "interval", FilterTemplate: (item: DataGridColumn) => {
          return (<InputItem title="" type="interval" name="flowMeasurements" onChange={(name, value, value2) => {
            (this.searchGrid.current as DataGrid).handleSort(name, value, value2)
          }} />)

        }
      });
      this.addColumn("Main", mainGridColumns, {
        Name: "imagingMeasurements", Type: "interval", Caption: "Imaging", FilterTemplate: (item: DataGridColumn) => {
          return (<InputItem title="" type="interval" name="imagingMeasurements" onChange={(name, value, value2) => {
            (this.searchGrid.current as DataGrid).handleSort(name, value, value2)
          }} />)

        }
      });
      this.addColumn("Main", mainGridColumns, { Name: "reports", Caption: "Reports",Type: "interval" });
      //this.addColumn("Main", mainGridColumns, { Name: "missingData", Caption: "Missing Data", Type: "boolean" });
      this.addColumn("Main", mainGridColumns, { Name: "measurements", Caption: "Measurement", Type: "interval", RenderTemplate: (item: PreviewMeasurement[], rowItem) => {
          let itemsOut = [];
          let index = 0;
          let labelsAdded: string[] = [];
          item.sort((a: PreviewMeasurement, b: PreviewMeasurement) => ((a.recordDate ? new Date(a.recordDate)?.getTime() : 0) - (b.recordDate ? new Date(b.recordDate)?.getTime() : 0)))
          let indexesAdded: number[] = [];
          while (itemsOut.length < 4 && index < item.length) {
            const element = item[index];
            let fullAnatomicalLocation = element.anatomicalLocations?.join("-") as string;
            if (!fullAnatomicalLocation)
              fullAnatomicalLocation = element.vessels?.join("-") as string;
            if (labelsAdded.indexOf(fullAnatomicalLocation) < 0 && (element.measurementType === "Imaging" || element.measurementType === "Flow" )) {
              indexesAdded.push(index);
              labelsAdded.push(fullAnatomicalLocation);
              itemsOut.push(<MeasurmentThumbnail key={"measurements" +  element.id} studySelected={this.props.studySelected} procedureId={rowItem.id} dataHelper={this.props.dataHelper} rowData={element as PreviewMeasurement} detailed={false} expanded={()=>
              {
                //When The top level thumb is expanded then deselect the row.
                (this.searchGrid.current as DataGrid).deselectRow();
              }
              } context={"searchpreview"}></MeasurmentThumbnail>);
            }

            index++;
          }
          index = 0;
          while (itemsOut.length < 4 && index < item.length) {
            //If there are still less than the magic number four then just add the remaining without worrying about label repeats
            const element = item[index];
            let fullAnatomicalLocation = element.anatomicalLocations?.join("-") as string;
            if (!fullAnatomicalLocation)
              fullAnatomicalLocation = element.vessels?.join("-") as string;
            if (indexesAdded.indexOf(index) < 0 && (element.measurementType === "Imaging" || element.measurementType === "Flow" || element.measurementType === "Aux" || element.measurementType === "Ecg" || element.measurementType === "PWDopplers"|| element.measurementType === "PWDoppler")) {
              labelsAdded.push(fullAnatomicalLocation);
              itemsOut.push(<MeasurmentThumbnail  key={"measurements" +  element.id} studySelected={this.props.studySelected} procedureId={rowItem.id} dataHelper={this.props.dataHelper} rowData={element as PreviewMeasurement} detailed={false} expanded={()=>
              {
                //When The top level thumb is expanded then deselect the row.
                (this.searchGrid.current as DataGrid).deselectRow();
              }
              } ></MeasurmentThumbnail>);
            }
            index++;
          }
        if (itemsOut && itemsOut.length > 0)
          return <div className="thumbnails-container">{itemsOut}</div>;
        else
          return <></>;
        }, FilterTemplate: (item: any) => {
          /*
          item.forEach(element => {
            if(element.measurementType=="Flow" || )
          });*/
          return (
            <div className="messurementFilterContainer">
      <InputItem title="Type" type="dropdown" name="measurementType" options={["--Select--","Flow", "Imaging", "Aux", "Ecg", "PWDopplers"]} deleteOption={(value) => { (this.searchGrid.current as DataGrid).removeFilter("measurementType", value) }} onChange={(name, value, value2) => {
                (this.searchGrid.current as DataGrid).handleSort("Measurement","measurements", value, null, "measurementType")
              }} />
              <InputItem title="MF" type="interval" name="measurements" deleteOption={(value) => { (this.searchGrid.current as DataGrid).removeFilter("mean", value) }} onChange={(name, value, value2) => {
                (this.searchGrid.current as DataGrid).handleSort("Measurement",name, value, value2, "mean")
              }} />
              <InputItem title="pI" type="interval" name="measurements" deleteOption={(value) => { (this.searchGrid.current as DataGrid).removeFilter("pI", value) }} onChange={(name, value, value2) => {
                (this.searchGrid.current as DataGrid).handleSort("Measurement",name, value, value2, "pI")
              }} />
              <InputItem title="dF" type="interval" name="measurements" deleteOption={(value) => { (this.searchGrid.current as DataGrid).removeFilter("dF", value) }} onChange={(name, value, value2) => {
                (this.searchGrid.current as DataGrid).handleSort("Measurement",name, value, value2, "dF")
              }} />
            
            </div>)
        }, SummaryTemplate: (rows: DataGridRow[]) =>
        {
          let totalmF = 0;
          let totaldF = 0;
          let totalPI = 0;
          let totalRows = 0;
          let totalDfRows = 0;
          let totalMfRows = 0;
          let totalPIRows = 0;
          for (let index = 0; index < rows.length; index++) {
            const element = rows[index] as PreviewProcedureModel;
            totalRows += element.measurements.length;
            for (let measindex = 0; measindex < element.measurements.length; measindex++) {
              const measurementIn = element.measurements[measindex];
              if (measurementIn.measurementType === "Flow")
              {
              if (!Number.isNaN(measurementIn.mean) && Math.abs(measurementIn.mean as number) > 0)
              {
                totalmF += Math.abs((measurementIn.mean as number)*1000);
                totalMfRows++;
              }
              if (!Number.isNaN(measurementIn.pI) && measurementIn.pI as number > -1 && measurementIn.pI as number < 99)
              { 
                //99 is considered invalid for PI for now.
                totalPI += measurementIn.pI as number;
                totalPIRows++;
              }
               
              if (!Number.isNaN(measurementIn.dF) && measurementIn.dF as number > 0)
              {
                totaldF += measurementIn.dF as number;
                totalDfRows++;
              }
            }
            }
         
          }
            return <div className="subTotalDisplay">
              {
                totalRows > 0   ?
                <><span className="subTotalDisplayItem">Avg MF: {totalMfRows > 0 ? (totalmF/totalMfRows).toFixed(2) : "--"}</span>
                <span className="subTotalDisplayItem">Avg PI: {totalPIRows > 0 ?(totalPI/totalPIRows).toFixed(2) : "--"}</span>
                <span className="subTotalDisplayItem">Avg DF: {totalDfRows > 0 ?(totaldF/totalDfRows).toFixed(2) : "--"}</span></>
             :
                <></>
              }
              
            </div>;
        }
      });
      this.addColumn("Main", mainGridColumns, 
      { Name: "otherComments", Caption: "Added Comments", Editable: true, searchChildren: true, Type: "textarea" , SummaryTemplate: (rows: DataGridRow[]) =>
      {
        let totalCases =  rows.length;

 
        return <div className="subTotalDisplay">
                <span className="subTotalDisplayItem">Cases: {totalCases}</span>
            </div>;
      }
      });
      this.addColumn("Main", mainGridColumns, 
      { Name: "createReport", Caption: "Report", RenderTemplate: this.renderToButton, SummaryTemplate: (rows: DataGridRow[]) =>
      {
        let totalMeasurements =  0;
        for (let index = 0; index < rows.length; index++) {
          const element = rows[index] as PreviewProcedureModel;
          totalMeasurements += element.measurements.length;
        }
        return <div className="subTotalDisplay">
                <span className="subTotalDisplayItem">Saves: {totalMeasurements}</span>
            </div>;
      } });
      
}
    return mainGridColumns;
  }

  measurementAllocated = (stepIndex: number, timeStepName: string, vesselName: string, procedureId: string, measurementId: string)=>
  {
      for (let index = 0; index < this.props.procedures.length; index++) {
        const element = this.props.procedures[index];
        if (element.id === procedureId)
        {
            for (let measindex = 0; measindex < element.measurements.length; measindex++) {
              const measurementelement = element.measurements[measindex];
              if (measurementelement.id === measurementId)
              {
                    measurementelement.stepLocations = VascularHelpers.addLocationAndRemoveElsewhere(stepIndex, timeStepName, vesselName, measurementelement.stepLocations);
                    
                    if (this.setProcotolStep(element, measurementelement))
                    {
                        this.saveFieldValue(element as PreviewProcedureModel, ["stepLocations", "protocolStep"], true, false);
                    }else
                    {
                        this.saveFieldValue(element as PreviewProcedureModel, ["stepLocations"], true, false);
                    }
              }
        
            }
        }
        
      }
      this.forceUpdate();
  }

    measurementAllocatedToOtherGraft = (grafts: Graft[], procedureType: string, timestep:string, procedureId: string, measurementId: string, graftId: string):void => 
  {
      for (let index = 0; index < this.props.procedures.length; index++) {
        const element = this.props.procedures[index];
        if (element.id === procedureId)
        {
            for (let measindex = 0; measindex < element.measurements.length; measindex++) {
              const measurementelement = element.measurements[measindex];
              if (measurementelement.id === measurementId)
              {
                if (graftId === "remove")
                {
                  (measurementelement as any).intuiGraft = null;
                   measurementelement.performedProcedureStep = "";
                   
                }else
                {
                    for (let graftIndex = 0; graftIndex < grafts.length; graftIndex++) {
                      const GraftIn = grafts[graftIndex];
                      let graftFound = Graft.findGraftWithId(GraftIn, GraftIn, graftId);
                      if (graftFound)
                      {
                        let duplicateGraft = JSON.parse(JSON.stringify(graftFound)) as Graft;
                        Graft.selectGraftWithId(duplicateGraft, graftId);
                        measurementelement.intuiGraft = duplicateGraft;
                        measurementelement.performedProcedureStep = timestep;
                        measurementelement.performedProcedure = procedureType;
                      }
                    }
                  }
                    this.saveFieldValue(element as PreviewProcedureModel, ["intuiGraft", "performedProcedure", "performedProcedureStep"], true, false);
                   
              }
        
            }
        }
        
      }
      this.forceUpdate();
  }

   updateExistingGraft= (graftChanged: Graft, procedureId: string):void => 
  {
      for (let index = 0; index < this.props.procedures.length; index++) {
        const element = this.props.procedures[index];
        if (element.id === procedureId)
        {
            for (let measindex = 0; measindex < element.measurements.length; measindex++) {
              const measurementelement = element.measurements[measindex];
                if ( measurementelement.intuiGraft)
                {
                  let graftFound = Graft.findGraftWithId(measurementelement.intuiGraft as Graft, measurementelement.intuiGraft as Graft, graftChanged.id as string);
                  if (graftFound)
                  {
                     let duplicateGraft = JSON.parse(JSON.stringify(graftChanged)) as Graft;
                     //Now attempt to select the part of the graft the measurement was linked to and only update it if the part still exists.
                     let foundSelected = Graft.recurseSelected(measurementelement.intuiGraft as Graft);
                     if (foundSelected) 
                      if (Graft.selectGraftWithId(duplicateGraft, foundSelected.id as string))
                        measurementelement.intuiGraft = duplicateGraft;
                      else
                        (measurementelement as any).intuiGraft = null;
                     
                  }
                }
            }
            this.saveFieldValue(element as PreviewProcedureModel, ["intuiGraft"], true, false);
        }
        
      }
      this.forceUpdate();
  }

  //In some studies the protocol step can be estimated from the stepLocations, anatomical locations and the orientation of the probe.
  setProcotolStep = (procedure: PreviewProcedureModel, measurement: PreviewMeasurement): boolean =>
  {
    let isSet = false;
      if (this.props.studySelected.studyType === "Vascular" && this.props.studySelected.protocolSteps && this.props.studySelected.protocolSteps.length > 8)
      {
          if (measurement.stepLocations && measurement.stepLocations.length > 0)
          {
            let firstStepLocation: StepLocationModel = measurement.stepLocations[0];
            let beforeAfter = firstStepLocation.timeStepIndex === 0 ? "Before" : "After";
            let anatomicalLocationIndex = procedure.anatomicalLocations.indexOf(firstStepLocation.name);
            let proximalDistal = "Proximal";
            if (anatomicalLocationIndex === procedure.anatomicalLocations.length -1)
            {
              //Assume if it's the final anatomical location in the list then it is distal
              proximalDistal = "Distal";
            }
            if (measurement.measurementType === "Flow" && beforeAfter === "Before" && proximalDistal === "Proximal")
            {
                measurement.protocolStep = this.props.studySelected.protocolSteps[0];
                isSet = true;
            }
            else if (measurement.measurementType === "Flow" && beforeAfter === "Before" && proximalDistal === "Distal")
            {
                measurement.protocolStep = this.props.studySelected.protocolSteps[1];
                  isSet = true;
            }
            else if (measurement.measurementType === "Flow" && beforeAfter === "After")
            {
                measurement.protocolStep = this.props.studySelected.protocolSteps[2];
                  isSet = true;
            }
            else if (measurement.measurementType === "Imaging" && measurement.orientation === "Transverse"  && proximalDistal === "Proximal" && measurement.operatingMode === "OperatingMode2D")
            {
                measurement.protocolStep = this.props.studySelected.protocolSteps[3];
                  isSet = true;
            }
             else if (measurement.measurementType === "Imaging" && measurement.orientation === "Longitudinal"  && proximalDistal === "Proximal" && measurement.operatingMode === "OperatingMode2D")
            {
                measurement.protocolStep = this.props.studySelected.protocolSteps[4];
                  isSet = true;
            }
             else if (measurement.measurementType === "Imaging" && measurement.orientation === "Longitudinal"  && proximalDistal === "Proximal" && measurement.operatingMode === "OperatingModeCFM")
            {
                measurement.protocolStep = this.props.studySelected.protocolSteps[5];
                  isSet = true;
            }
             else if (measurement.measurementType === "Imaging" && measurement.orientation === "Transverse"  && proximalDistal === "Distal" && measurement.operatingMode === "OperatingMode2D")
            {
                measurement.protocolStep = this.props.studySelected.protocolSteps[6];
                  isSet = true;
            }
            else if (measurement.measurementType === "Imaging" && measurement.orientation === "Longitudinal"  && proximalDistal === "Distal" && measurement.operatingMode === "OperatingMode2D")
            {
                measurement.protocolStep = this.props.studySelected.protocolSteps[7];
                  isSet = true;
            }
            else if (measurement.measurementType === "Imaging" && measurement.orientation === "Longitudinal"  && proximalDistal === "Distal" && measurement.operatingMode === "OperatingModeCFM")
            {
                measurement.protocolStep = this.props.studySelected.protocolSteps[8];
                  isSet = true;
            }
          }

      }
      return isSet;
  }

  orientationChanged = (orientation: string, procedureId: string, measurementId: string)=>
  {
      for (let index = 0; index < this.props.procedures.length; index++) {
        const element = this.props.procedures[index];
        if (element.id === procedureId)
        {
            for (let measindex = 0; measindex < element.measurements.length; measindex++) {
              const measurementelement = element.measurements[measindex];
              if (measurementelement.id === measurementId)
              {
                    measurementelement.orientation = orientation;
                    
                    if (this.setProcotolStep(element, measurementelement))
                    {
                        this.saveFieldValue(element as PreviewProcedureModel, ["orientation", "protocolStep"], true, false);
                    }else
                    {
                      this.saveFieldValue(element as PreviewProcedureModel, ["orientation"], true, false);
                    }
              }
        
            }
        }
        
      }
      this.forceUpdate();
  }

  procedureTypeChanged = (procedureType: string, procedureId: string)=>
  {
    //TODO: This is a bit of an oversite but if the procedure type is changed then all measurements under it are changed to match. This may not be the desired behaviour.
      for (let index = 0; index < this.props.procedures.length; index++) {
        const element = this.props.procedures[index];
        if (element.id === procedureId)
        {
            for (let measindex = 0; measindex < element.measurements.length; measindex++) {
              const measurementelement = element.measurements[measindex];
                    measurementelement.performedProcedure = procedureType;

                    this.saveFieldValue(element as PreviewProcedureModel, ["performedProcedure"], true, false);
            }
        }
        
      }
      this.forceUpdate();
  }

  saveFieldValue = (rowdata: PreviewProcedureModel, columnChanged: string[], updateMeasurements: boolean, showLoading: boolean) =>
  {
    this.props.dataHelper.CallStudyService("SaveProcedure", { studyId: this.props.studySelected.id, previewProcedure: rowdata, updateMeasurements: updateMeasurements, columnChanged: columnChanged }, {}, (dataOut: string) => {
                if (dataOut)
                {
                  let showTo = JSON.parse(dataOut);
                  if (showTo === "DONE")
                  {
                    if (showLoading)
                    (this.infoBox.current as InfoBox).show("Procedure '" + columnChanged + "' saved");
                  }
                  else
                    (this.errorWindow.current as ErrorWindow).show(700, showTo );

                }else
                {
                  (this.errorWindow.current as ErrorWindow).show(700, dataOut);
                
              }}, (stautus: number, errorMessage: string) => { (this.errorWindow.current as ErrorWindow).show(stautus, errorMessage) }, "POST", showLoading);
  }


  render() {
    let steps = ["Select"].concat(this.props.studySelected.protocolSteps as string[]);
    let labelOptions: string[] = (this.props.studySelected.suggestedLabels?.map((item)=>{
      return item.name;
    }) as  string[]);
    let hospitalsList: string [] = ["--Select--"];
    for (let index = 0; index < this.props.procedures.length; index++) {
      const element = this.props.procedures[index];
      if (hospitalsList.indexOf(element.hospitalName) === -1)
        hospitalsList.push(element.hospitalName);
      
    }

   let mainGridColumns: DataGridColumn [] = this.getMainColumns(labelOptions, hospitalsList);
   let childGridColumns: DataGridColumn [] = this.getChildColumns(steps);
    let defaultFilter: SortVal[] = [];
     if (this.props.userView === viewType.Minimal)
    {
      defaultFilter.push({
        category: "measurements",
        value: "Ecg",
        valueEnd: undefined,
        measurementType: "measurementType",
        capiton: "Measurement",
        overrideType: "",
        ignoreChildren: false,
        searchChildren: false,
        opposite: true
      });
    }
    let measurementsToShow = 18;
    if (this.props.userView === viewType.Minimal)
      if (this.props.studySelected.studyType === "Vascular")
        measurementsToShow = 6;
      else if (this.props.studySelected.studyType === "Cardiac")
        measurementsToShow = 6;
    return (
      <>
        
        <div>
          <ErrorWindow ref={this.errorWindow}></ErrorWindow>
      { 
    //   this.props.exportMode ?
    //   <div className="exportbuttons">
    //   {/* {this.state.includeMeasurements ? 
    //     <button className="primaryButton" onClick={() => { this.setState({ includeMeasurements: false }) }}>Exclude measurements</button> 
    //     :<button className="primaryButton" onClick={() => { this.setState({ includeMeasurements: true }) }}>Include measurements</button>} */}
    //   <button className="primaryButton" onClick={() => {
    //     let exportData: ExportModel = {includeMeasurements: this.state.includeMeasurements, procedures: [] }
        
    //     if (this.props.toggleFilter){
    //       let filteredData: PreviewProcedureModel[] = [...(this.searchGrid.current as DataGrid).getFilteredData(this.state.includeMeasurements) as PreviewProcedureModel[]] ;
    //       exportData.procedures = filteredData.filter(data => data.selected);
    //     }else
    //     {
    //       exportData.procedures = this.props.procedures;
    //     }
    //     this.props.dataHelper.CallMetadataService("ExportData", exportData,{}, (resultOut: string) => {
    //       let filename = JSON.parse(resultOut);
    //        this.props.dataHelper.downloadFile("StudyMetadata", "GetFile", {fileid: filename})
    //     },(status:number, errorMessage:string)=>{ (this.errorWindow.current as ErrorWindow).show(status, errorMessage)},"POST");
    //   }}>Export</button>
      
    // </div>
    // : <></>
    }
          
          <DataGrid ref={this.searchGrid} rowSelected={()=>{
            this.setState({
              newGraftToAdd: null
            });
          }} defaultFilter={defaultFilter} extraclass={"mode"+this.props.userView} includeBlankMeasurements={this.state.showEmptyFlows} extraclasschild={"childmode"+this.props.userView} returnErrorBox={this.handleErrorBox} returnInfoBox={this.handleInfoBox} key={"SearchGrid_"+ this.props.procedures.length + "_" + this.props.studySelected.name} studySelected={this.props.studySelected} usePaging={true} pageSize={100} usePagingChild={true} pageSizeChild={measurementsToShow} isFilterable={this.props.toggleFilter} onChange={(rowdata: DataGridRow, columnChanged: string, value: any, index: number | undefined, submitToServer: boolean | undefined) => {

            (this.searchGrid.current as DataGrid).forceUpdate();

this.props.procedureItemUpdated((rowdata as any)["id"], columnChanged, value)

            // (rowdata as any)[columnChanged] = value;
            if (submitToServer) {
                 this.saveFieldValue(rowdata as PreviewProcedureModel, [columnChanged], false, true);
            }
          }}
            sort={(name: string, value: any) => {
            }}
            onChildChange={(rowdata: DataGridRow, parentrowdata: DataGridRow, columnChanged: string, value: any, index: number | undefined, parentIndex: number | undefined, submitToServer: boolean | undefined) => {

              this.forceUpdate();
              if (submitToServer) {
                this.saveFieldValue(parentrowdata as PreviewProcedureModel, [columnChanged], true, true);
              }
            }}
            columns={mainGridColumns} rows={this.props.procedures} hasHierarchy={!this.props.exportMode || this.state.includeMeasurements } childrenpropertyname="measurements" includeadvancedoptions={this.props.userView === viewType.Advanced} childcolumns={childGridColumns} grouping={true} groupingpropertyname="hospitalName" getChildGridRowAlternateColor={(item: DataGridRow) => {
              return ((item as PreviewMeasurement).measurementSetIndex as number) % 2 !== 0;
            }} additionalFooterOptions={<InputItem type='boolean' name='ShowBlanks' title={"Show blank measurements "} value={this.state.showEmptyFlows} onChange={(name:string, value:any) => {

              this.setState({
                showEmptyFlows: value === 'true'
              });
              
              }}></InputItem>}
            
            FirstRowToAddInChild={(parentRow: DataGridRow)=>{
              
              if (this.props.userView === viewType.Minimal && this.props.studySelected.studyType === "Vascular")
              {
                  let height = 640;
                  let width = 224;
                  return <tr className="thumbItem graftBuilderTR">
                    <td colSpan={4} className="mainDrawingContainer vascularCanvas" style={{height: height, width: width}}><PeripheralDrawingOverlay measurementAllocated={this.measurementAllocated} dataHelper={this.props.dataHelper} studySelected={this.props.studySelected} parentProcedure={(parentRow as PreviewProcedureModel)} dragDropEnabled={false} targetRadius={7} jointRadius={7} graftAdded={(itemIn: string) =>{
                    let foundIndex = (parentRow as PreviewProcedureModel).anatomicalLocations.indexOf(itemIn);
                    if (foundIndex > -1)
                    {
                        (parentRow as PreviewProcedureModel).anatomicalLocations.splice(foundIndex, 1);
                          //Next loop through all measurements and remove anywhere that item is used.
                          for (let index = 0; index <  (parentRow as PreviewProcedureModel).measurements.length; index++) {
                            const element =  (parentRow as PreviewProcedureModel).measurements[index];
                            element.stepLocations = VascularHelpers.removeVesselFromLocations(itemIn, element.stepLocations);
                          }
                    }
                      else
                        (parentRow as PreviewProcedureModel).anatomicalLocations.push(itemIn);

                  
                    
                    this.saveFieldValue(parentRow as PreviewProcedureModel, ["anatomicalLocations"], false, false);
                    this.saveFieldValue(parentRow as PreviewProcedureModel, ["stepLocations"], true, false);
                    (this.searchGrid.current as DataGrid).forceUpdate();
                  }} swapSide={(sideUsed: string) => {
                      (parentRow as PreviewProcedureModel).sideUsed = sideUsed;
                      this.props.procedureItemUpdated((parentRow as any)["id"], "sideUsed", sideUsed);

                         this.saveFieldValue(parentRow as PreviewProcedureModel, ["sideUsed"], false, false);
                       (this).forceUpdate();
                  }} GraftsLoaded={VascularHelpers.createGraftsFromLabels((parentRow as PreviewProcedureModel).anatomicalLocations)} absxOffset={-48} absyOffset={-10} height={height} width={width} Context="TTFM" drawDebugLine={false} selectedProcedure={{name: "PeripheralBypass", title: "", type: "Vascular"}} heartxOffset={0 } heartyOffset={-30} customGraftLocation={new TargetLocation()} heartTargetsShow={false} heartOutlineShow={true} editGraftClicked={()=>{}} graftSelected={new Graft()}></PeripheralDrawingOverlay>
                  </td>
                  </tr>;
              }else if (this.props.userView === viewType.Minimal && this.props.studySelected.studyType === "Cardiac")
              {
                  let height = 640;
                  let width = 224;

                  let grafts: Graft[] = [];
                  let graftIdsAdded: string[] = [];
                  let procedureTypes =[];
                  for (let index = 0; index < (parentRow as PreviewProcedureModel).measurements.length; index++) {
                      const element = (parentRow as PreviewProcedureModel).measurements[index];
                      if (element.intuiGraft) {
                        if (graftIdsAdded.indexOf((element.intuiGraft as Graft).id as string) === -1)
                        {
                          grafts.push(element.intuiGraft as Graft);
                          graftIdsAdded.push((element.intuiGraft as Graft).id as string);
                        }
                      }
                      if (element.performedProcedure && element.performedProcedure !== "" )
                      {
                        //We only support one procedure type in a case for now
                        if (procedureTypes.indexOf( element.performedProcedure) === -1)
                          procedureTypes.push(element.performedProcedure);
                      }
                  }
                  if (procedureTypes.length === 0)
                  {
                    procedureTypes = [Object.keys(Graft.CardiacProcedureTypesLookup)[0]];
                  }
                  if (this.state.newGraftToAdd)
                    grafts.push(this.state.newGraftToAdd);
                  return <tr className="cardiacBuilder thumbItem graftBuilderTR">
                    <td colSpan={4} className="mainDrawingContainer" style={{height: height, width: width}}>
                    <CardiacWorklist procedureTypes={procedureTypes} changeProcedureType={(procedureType: string)=>{
                      this.procedureTypeChanged(procedureType, (parentRow as PreviewProcedureModel).id as string);
                    }} addNewGraft={(newGraft: Graft) =>
                     {
                        //For adding we just add the graft to the list added. The user then needs to allocate at least one measurement to it to save it.
                        this.setState({
                          newGraftToAdd: newGraft
                        }); 
                     }
                    }
                    updateExistingGraft={(updatedGraft: Graft) =>
                     {
                        //Updating is a bit more complex as we need to update all measurements that use this graft.
                        this.updateExistingGraft(updatedGraft, (parentRow as PreviewProcedureModel).id as string);
                     }
                    }
                     CurrentItems={grafts} TimeSteps={["Hello Sailor"]} measurementAllocated={(procedureType: string,timeStep: string, procedureId: string, measurementId: string, graftId: string) => {
                      
                      
                      this.measurementAllocatedToOtherGraft(grafts,procedureType, timeStep, procedureId, measurementId, graftId);
                      if (this.state.newGraftToAdd &&  Graft.findGraftWithId(this.state.newGraftToAdd as Graft, this.state.newGraftToAdd as Graft, graftId))
                      {
                        this.setState({
                          newGraftToAdd: null,

                        });
                      }
                    }} studySelected={this.props.studySelected} dataHelper={this.props.dataHelper} parentProcedure={(parentRow as PreviewProcedureModel)}></CardiacWorklist>
                  </td>
                  </tr>;
              }
              else
              return <></>;

            }}></DataGrid>
          <InfoBox ref={this.infoBox} title="Confirmation" type="confirmation"></InfoBox>
        </div>
      </>
    );
  }
}
